import { TagsInput as MantineTagsInput } from '@mantine/core';

export const TagsInput = MantineTagsInput.extend({
	defaultProps: {
		'data-test-id': 'tags-input',
		allowDuplicates: false,
	},
});
